import { Intent } from '@blueprintjs/core';
import type { AxiosError } from 'axios';
import axios from 'axios';
import * as qs from 'qs';
import type { Dispatch } from 'redux';
import type { ThunkDispatch } from 'redux-thunk';

import AppToaster from 'vms/app/AppToaster';
import { store, history } from 'vms/app/configureApp';
import type { RootState } from 'vms/app/rootReducer';
import RecentVehicles from 'vms/features/vehicles/RecentVehicles';

import { LOGIN_SUCCESS } from './actionTypes';
import type { User } from './types';

export const handleLoginSuccess =
  ({ user }: { user: User }) =>
  (dispatch: Dispatch<any>) => {
    localStorage.setItem('user', JSON.stringify(user));
    dispatch({
      type: LOGIN_SUCCESS,
      user,
    });
    history.replace('/');
  };

export const handleUnauthorized = () => {
  localStorage.removeItem('user');
  RecentVehicles.clearHistory();
  window.location.href = '/login/';
};

const initUser = () => (dispatch: Dispatch<any>) => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    dispatch({
      type: LOGIN_SUCCESS,
      user: JSON.parse(userStr),
    });
  }
};

export const logout = () => () =>
  axios.post('/logout/').then(handleUnauthorized, () =>
    AppToaster.show({
      message: 'Network problem, please try again!',
      intent: Intent.DANGER,
    })
  );

const initAuthSystem = () => (dispatch: ThunkDispatch<RootState, undefined, any>) => {
  dispatch(initUser());
  axios.defaults.headers.common = {
    ...axios.defaults.headers.common,
    'X-Requested-With': 'XMLHttpRequest',
  };
  axios.defaults.xsrfCookieName = 'csrftoken';
  axios.defaults.xsrfHeaderName = 'X-CSRFToken';
  axios.defaults.baseURL = '/api/v1/';
  axios.defaults.paramsSerializer = (params) =>
    qs.stringify(params, { arrayFormat: 'repeat' });
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error: AxiosError) => {
      if (
        error.response &&
        error.response.status === 401 &&
        history.location.pathname !== '/login/'
      ) {
        handleUnauthorized();
        // oxlint-disable-next-line no-console
        console.log('auth failure');
      }
      if (error.response && error.response.status === 400) {
        // temporary for debug
        // oxlint-disable-next-line no-console
        console.log(`ERROR: ${JSON.stringify(error.response.data)}`);
      }
      return Promise.reject(error);
    }
  );
};

store.dispatch(initAuthSystem());
export { LOGIN_SUCCESS, UNAUTHORIZED_RESPONSE, SAVE_LAST_LOCATION } from './actionTypes';
